import React from "react";
import { Image } from "semantic-ui-react";
import Lazyload from 'react-lazyload'
import { useSelector } from "react-redux";
import blackCheckIcon from '../../../../images/products/icon/banner icon/black_check_icon.svg';
import whiteCheckIcon from '../../../../images/products/icon/banner icon/white_check_icon.svg';
import "./ProductsBanner.css";

const ProductsBanner = props => {
  const { languageTable: lang } = useSelector(state => state.langAction)
  let { name, image, description, descriptionStyle, ChildComponent } = props;
  let checkIcon;
  if (descriptionStyle?.color === "white") {
    checkIcon = whiteCheckIcon;
  } else {
    checkIcon = blackCheckIcon;
  };
  return (
    <div className="__d_products_picture_block">
      <div className="ui fluid image">
        {description && (
          <div className="__d_products_picture_block_description" style={descriptionStyle}>
            {
              description.map((i, n) => (
                <div className="__d_products_picture_block_description_item" key={n}>
                  <img src={checkIcon} alt="banner description icon" />
                  <span>{lang.get(i)}</span>
                </div>
              ))
            }
          </div>
        )}
        <div className="__d_products_picture_block_name">{props.name}</div>
        <Lazyload height={0}>
          <Image src={props.image} alt='Digital Signage Display' />
        </Lazyload>
        {ChildComponent && ChildComponent(lang)}
      </div>
    </div>
  );
}

export default ProductsBanner
